import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  public url : string;
  private BASE_URL:string = window["cfgApiBaseUrl"];
  private TCC_REPORT_URL:string = this.BASE_URL+"tccreportdata";
  private _repData: Array<any>;

  public get repData(): Array<any> {
    return this._repData;
  }
  
  constructor(private http : HttpClient) { }

  public getReportData():Observable<any>{
    return this.http.get<any>(this.TCC_REPORT_URL).pipe(
      map( res =>{
        this._repData = res;
        return true;
      }),
      catchError(this.errorHandler));
  }

  public getReportData1():Observable<Array<any>>{
    return this.http.get<any>(this.TCC_REPORT_URL);
  }

  errorHandler(error : HttpErrorResponse){
     return throwError(error.message || "Server Error");
   }
}
